export function transformNumber(value) {
  if (value == null) {
    return 0;
  }
  return value;
}

export function transformString(value) {
  if (value == null) {
    return '';
  }
  return value;
}

export function ransformArray(value) {
  if (value == null) {
    return [];
  }
  return value;
}



// WEBPACK FOOTER //
// ./src/scripts/utils/transformType.js